'use strict';

/*
 created by ws 2022-08-08
 */
//1.module 模块
var app = angular.module('iwoIssueManuscriptModule', [])

//2.controller 控制器
app.controller('iwoIssueManuscriptCtrl',
    function ($scope,
              $q,
              $window,
              $state,
              modalDialog,
              $stateParams,
              $timeout,
              trsHttpService) {

        initStatus()
        initData()

        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                isESSearch: false,
            };
            $scope.params = {
                serviceid: 'mlf_departoperdoc',
                methodname: 'quertDeptDocs',
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                DeptmentalDocId: $stateParams.departmentDocId,
            };
            $scope.data = {
                // 提交人输入框
                inputPerson: '',
                // 提交人初始下拉框数据
                submitPerson: [],
                items: [],
                selectedArray: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };
            $scope.status = {
                departmentDocId: $state.params.departmentDocId,
                btnRights: {},
                hasphoto: false, // 是否是图集稿
                imgConcat: false, // 判断是否是图集，进行追加数组
                copyCurrPage: 1,
                hasphotoflag: true,
            };
            // 查询筛选提交人
            $scope.searchParams = {
                methodname: 'queryUsersByName',
                serviceid: 'mlf_extuser',
                IsSearchAll: true,
                Name: '',
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
        }

        function initData() {
            getDepartPersonList();
        }

        function getDepartPersonList() {
            var params = JSON.parse(JSON.stringify($scope.params));
            params.methodname = 'quertDeptDocsSubmitUser';
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.PersonList = data;
            });
        }
    });

